import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/SearchRounded";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#838E93"
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#838E93"
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#838E93"
      }
    },
    "& .MuiOutlinedInput-input::placeholder": {
      color: "#838E93",
      opacity: 1
    },
    "& .MuiOutlinedInput-adornedStart": {
      paddingLeft: 8
    }
  },
  icon: {
    width: 25,
    height: 25
  }
}));

interface SearchTextFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  fullWidth?: boolean;
  autoFocus?: boolean;
}

export default function SearchTextField({
  value,
  onChange,
  placeholder = "Search",
  className,
  fullWidth,
  autoFocus = false
}: SearchTextFieldProps) {
  const classes = useStyles();

  return (
    <TextField
      variant="outlined"
      size="small"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={`${classes.root}${className ? ` ${className}` : ""}`}
      fullWidth={fullWidth}
      autoFocus={autoFocus}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon className={classes.icon} />
          </InputAdornment>
        )
      }}
    />
  );
}
